<template>
  <div>
    <div class="container" style="padding: 0;">
      <div class="card" style="padding: 0px; min-height: 0;">

        <!-- 充值操作 -->
        <van-dialog v-model="visible" width="100%" style="height:90%" class="editClue" show-cancel-button>
          <template slot="title">
            <van-radio-group v-model="type" direction="horizontal" @change="selectType" v-if="!fromPage">
              <van-radio name="recharge">充值申请</van-radio>
              <van-radio name="transfer">调拨</van-radio>
              <van-radio name="refund">退款</van-radio>
            </van-radio-group>
            <span v-if="fromPage">
              <span v-if="type === 'recharge'">充值</span>
              <span v-if="type === 'transfer'">调拨</span>
              <span v-if="type === 'refund'">退款</span>
            </span>
          </template>
          <van-search v-if="type !== 'transfer'" v-model="accountId" show-action type="number" clearable label="账户ID" placeholder="请输入准确的账户ID" @search="onSearch">
            <template #action>
              <div @click="onSearch()">校验</div>
            </template>
          </van-search>
          <template v-else>
            <van-search v-model="accountId" show-action type="number" clearable label="调出账户ID" placeholder="请输入准确的账户ID" @search="onSearch">
              <template #action>
                <div @click="onSearch()">校验</div>
              </template>
            </van-search>
            <van-search v-if="accountIdInfo.contractId" v-model="allotAccountId" show-action type="number" clearable label="调入账户ID" placeholder="请输入准确的账户ID" @search="onSearchTransfer">
              <template #action>
                <div @click="onSearchTransfer()">校验</div>
              </template>
            </van-search>
          </template>
          <template v-if="accountIdInfo.contractId">
            <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">{{ type === 'transfer'?'调出合同信息':'合同信息'}}</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">合同编号：</span>
                <span class="value">{{ accountIdInfo.contractNum }}</span>
              </div>
              <div class="item" style="padding-left: 70px;text-indent: -70px;">
                <span class="key">合同名称：</span>
                <span class="value">{{ accountIdInfo.contractName }}</span>
              </div>
              <div class="item" style="padding-left:125px;text-indent:-125px;">
                <span class="key">我方签约主体机构：</span>
                <span class="value">{{ accountIdInfo.companyName }}</span>
              </div>
              <div class="item" >
                <span class="key">合同执行时间：</span>
                <span class="value">{{ accountIdInfo.startTime }}至{{ accountIdInfo.endTime }}</span>
              </div>
              <div class="item" >
                <span class="key">代运营服务费：</span>
                <span class="value" style="color: #ee0a24;">{{ accountIdInfo.agentBussFee }}%</span>
              </div>
              <div class="item" >
                <span class="key">签约信息：</span>
                <span class="value">{{ accountIdInfo.deptName }}<span style="margin-left: 5px;color: #1989fa">{{ accountIdInfo.userName }}</span></span>
              </div>
              <div class="item" v-if="accountIdInfo.execCustomerId">
                <span class="key" style="color: #1989fa !important;">执行客户：</span>
                <span class="value">{{ accountIdInfo.execCustomerName }}</span>
              </div>
              <div class="item" v-if="accountIdInfo.agentBusinessMoney || accountIdInfo.agentBusinessMoney == 0">
                <span class="key" style="color: #1989fa !important;">代运营服务费：</span>
                <span class="value" style="color: #ee0a24;">{{ accountIdInfo.agentBusinessMoney }}%</span>
              </div>
            </div>
          </template>
          <project-point-detail v-show="accountIdInfo.contractId" ref="projectPointDetail" />

          <template v-if="accountIdInfo.contractId && type === 'recharge'">
            <van-collapse v-model="activeNames">
              <van-collapse-item name="1">
                <template #title>
                  <span style="color: #1989fa;">申请信息</span><span style="color: #ff976a;font-size: 12px;">(点击可{{ activeNames.includes('1')?'收起':'展开' }}列表)</span>
                </template>
                <van-cell title="充值类型" />
                <van-cell style="padding-left: 15px;">
                  <template>
                    <van-radio-group v-model="dataType" direction="horizontal" @change="selectDataType">
                      <van-radio :name="1" clickable>预充值</van-radio>
                      <van-radio :name="3" clickable>垫款充值</van-radio>
                      <van-radio :name="5" clickable>备款充值</van-radio>
                      <van-button v-if="paymentList.length > 0" type="info" @click="toggleAll" size="mini">全选</van-button>
                    </van-radio-group>
                  </template>
                </van-cell>
                <van-list v-if="paymentList.length > 0">
                  <van-checkbox-group v-model="chooseList" ref="checkboxGroup" @change="checkChange">
                    <van-cell v-for="(item,index) in paymentList" :key="index">
                      <div style="display: flex; align-items: center; width:100%">
                        <van-checkbox :name="item" style="margin-right: 10px;" shape="square"></van-checkbox>
                        <div style="flex: 1;color: #333;font-size: 12px">
                          <div style="color: #333; font-size: 12px">
                            <template v-if="dataType===1">
                              <div>充值剩余金额：<span style="color: #ee0a24;">{{ item.rechargeRemainMoney }}</span> &nbsp;&nbsp;&nbsp;&nbsp; 收款金额：<span>{{ item.incomePayMoney }}</span></div>
                              <!-- <div></div> -->
                              <div>垫款回款金额：<span>{{ item.advancesInMoney }}</span> &nbsp;&nbsp;&nbsp;&nbsp;预充值金额：<span>{{ item.preRechargeMoney }}</span></div>
                              <!-- <div></div> -->
                              <div>付款单位：<span>{{ item.custName }}</span></div>
                              <div>收款时间：<span>{{ item.incomePayDate }}</span></div>
                              <div>收款主体：<span>{{ item.incomeCompanyName }}</span></div>
                              <div>银行名称：<span>{{ item.incomePayBank }}</span></div>
                            </template>
                            <template v-if="dataType===3">
                              <div>充值剩余金额：<span style="color: #ee0a24;">{{ item.rechargeRemainMoney }}</span></div>
                              <div>充值过期时间：<span>{{ item.rechargeTime }}</span></div>
                              <div>垫款金额：<span>{{ item.payMoney }}</span></div>
                              <div>垫款周期：<span>{{item.creditCycleType?`${item.creditCycleValue}个${formatHandel('creditCycleType',item.creditCycleType)}`:'--'}}</span></div>
                              <div>垫款类型：<span>{{ formatHandel('advancesType',item.advancesType) }}</span></div>
                              <div>垫款事由：<span>{{ item.advancesReason }}</span></div>
                            </template>
                            <template v-if="dataType===5">
                              <div>充值剩余金额：<span style="color: #ee0a24;">{{ item.rechargeRemainMoney }}</span></div>
                              <div>合同编号：<span>{{ item.contractNum }}</span></div>
                              <div>合同标题：<span>{{ item.contractName }}</span></div>
                              <div>执行客户名称：<span>{{ item.execCustomerName }}</span></div>
                            </template>
                            <div>{{ dataType===1?'认领信息':dataType===3?'垫款申请信息':'备款申请信息' }}：{{ item.deptName }}<span style="margin-left: 5px;color: #1989fa">{{ item.userName }}</span></div>
                            <div>{{ dataType===1?'认领时间':dataType===3?'垫款时间':'备款时间' }}：<span>{{ item.createTime }}</span></div>
                          </div>
                        </div>
                      </div>
                    </van-cell>
                  </van-checkbox-group>
                </van-list>
                <van-empty v-else :description="dataType===1?'暂无收款认领信息':dataType===3?'暂无垫款申请信息':'暂无备款申请信息'" />
              </van-collapse-item>
            </van-collapse>
            <van-form ref="rechargeForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height: auto; overflow: hidden;">
              <template v-if="chooseList.length > 0">
                <van-cell v-if="paymentList.length > 0 && paymentList[0].occupancyMoney" title="已申请记录占用金额：" :value="paymentList[0].occupancyMoney" style="color: #ee0a24;" />
                <van-cell title="充值剩余总额：" :value="rechargeForm.rechargeRemainMoney" style="color: #ee0a24;" />
                <van-field readonly clickable v-model="rechargeForm.serviceName" @click="showPicker('serviceId','rechargeForm')" label="所属服务商ID" placeholder="请选择所属服务商ID" :rules="[{ required: true }]" required />
                <template v-if="accountIdInfo.accountType === 2">
                  <!-- <van-cell v-if="rechargeForm.deposit_amount" title="需预留保证金：" :value="transferForm.deposit_amount" /> -->
                  <van-cell v-if="rechargeForm.cash_transfer_balance || rechargeForm.cash_transfer_balance == 0" title="所属服务商通用余额：" :value="rechargeForm.cash_transfer_balance" />
                </template>
                <template v-if="accountIdInfo.accountType === 1">
                  <van-cell v-for="(item, index) in tencentMapList" :key="index" :title="item.fundType" :value="item.balance" />
                </template>
                <van-cell title="充值类型：" required>
                  <template>
                    <van-radio-group v-model="rechargeForm.mediaRechargeType" direction="horizontal" :disabled="accountIdInfo.accountType == 2">
                      <van-radio :name="1" clickable>直充</van-radio>
                      <van-radio :name="2" clickable>子账户子户</van-radio>
                    </van-radio-group>
                  </template>
                </van-cell>
                <van-field v-if="rechargeForm.mediaRechargeType === 2" readonly clickable v-model="rechargeForm.subAccountName" @click="showPicker('subAccountId','rechargeForm')" label="子账户ID" placeholder="请选择子账户ID" :rules="[{ required: true }]" required />
                <van-field v-if="accountIdInfo.accountType == 1" readonly clickable v-model="rechargeForm.tenFundTypeName" @click="showPicker('tenFundType','rechargeForm')" label="资金账号类型" placeholder="请选择资金账号类型" :rules="[{ required: true }]" required />
                <van-field v-model="rechargeForm.rechargeMoney" @blur="getPayMoney('rechargeMoney',rechargeForm.rechargeMoney,'rechargeForm')" label="账户币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
                <van-field v-model="rechargeForm.payMoney" @blur="getPayMoney('payMoney',rechargeForm.payMoney,'rechargeForm')" label="现金金额(元)" placeholder="请输入现金金额" type="number" :rules="[{ required: true }]" required >
                  <template slot="right-icon">￥</template>
                </van-field>
              </template>
            </van-form>
          </template>

          <template v-if="allotAccountIdInfo.contractId">
            <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">调入合同信息</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">合同编号：</span>
                <span class="value">{{ allotAccountIdInfo.contractNum }}</span>
              </div>
              <div class="item" style="padding-left: 70px;text-indent: -70px;">
                <span class="key">合同名称：</span>
                <span class="value">{{ allotAccountIdInfo.contractName }}</span>
              </div>
              <div class="item" style="padding-left:125px;text-indent:-125px;">
                <span class="key">我方签约主体机构：</span>
                <span class="value">{{ allotAccountIdInfo.companyName }}</span>
              </div>
              <div class="item" >
                <span class="key">合同执行时间：</span>
                <span class="value">{{ allotAccountIdInfo.startTime }}至{{ allotAccountIdInfo.endTime }}</span>
              </div>
              <div class="item" >
                <span class="key">代运营服务费：</span>
                <span class="value" style="color: #ee0a24;">{{ allotAccountIdInfo.agentBussFee }}%</span>
              </div>
              <div class="item" >
                <span class="key">签约信息：</span>
                <span class="value">{{ allotAccountIdInfo.deptName }}<span style="margin-left: 5px;color: #1989fa">{{ allotAccountIdInfo.userName }}</span></span>
              </div>
              <div class="item" v-if="allotAccountIdInfo.execCustomerId">
                <span class="key" style="color: #1989fa !important;">执行客户：</span>
                <span class="value">{{ allotAccountIdInfo.execCustomerName }}</span>
              </div>
              <div class="item" v-if="allotAccountIdInfo.agentBusinessMoney || allotAccountIdInfo.agentBusinessMoney == 0">
                <span class="key" style="color: #1989fa !important;">代运营服务费：</span>
                <span class="value" style="color: #ee0a24;">{{ allotAccountIdInfo.agentBusinessMoney }}%</span>
              </div>
            </div>
          </template>
          <project-point-detail v-show="allotAccountIdInfo.contractId" ref="projectPointTransfer" />
          <template v-if="accountIdInfo.contractId && allotAccountIdInfo.contractId && type === 'transfer'">
            <van-form ref="transferForm" validate-trigger="onSubmit" class="refundForm" style="height: auto; overflow: hidden;">
              <template v-if="accountIdInfo.accountType === 2">
                <van-cell v-if="transferForm.deposit_amount" title="需预留保证金：" :value="transferForm.deposit_amount" />
                <van-cell v-if="transferForm.cash_transfer_balance || transferForm.cash_transfer_balance == 0" title="可转账户币余额：" :value="transferForm.cash_transfer_balance" />
              </template>
              <template v-if="accountIdInfo.accountType === 1">
                <van-cell v-for="(item, index) in tencentMapList" :key="index" :title="item.fundType" :value="item.balance" />
              </template>
              <van-field v-model="transferForm.rechargeMoney" label="账户币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
              <van-field readonly clickable v-model="transferForm.allotServiceName" @click="showPicker('serviceId','transferForm')" label="调入服务商ID" placeholder="请选择调入服务商ID" :rules="[{ required: true }]" required />
              <van-cell title="是否平调" required v-hasPermi="['is:same:rebate']">
                <template>
                  <van-radio-group v-model="transferForm.isSameRebate" direction="horizontal">
                    <van-radio :name="1" clickable>是</van-radio>
                    <van-radio :name="2" clickable>否</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <van-cell title="是否跨合同调拨" required v-hasPermi="['is:cross:cont']">
                <template>
                  <van-radio-group v-model="transferForm.isCrossCont" direction="horizontal">
                    <van-radio :name="1" clickable>是</van-radio>
                    <van-radio :name="2" clickable>否</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <van-cell title="充值类型" required>
                <template>
                  <van-radio-group v-model="transferForm.mediaRechargeType" direction="horizontal" :disabled="accountIdInfo.accountType == 2">
                    <van-radio :name="1" clickable>直充</van-radio>
                    <van-radio :name="2" clickable>子账户子户</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <van-field v-if="transferForm.mediaRechargeType === 2" readonly clickable v-model="transferForm.subAccountName" @click="showPicker('subAccountId','transferForm')" label="子账户ID" placeholder="请选择子账户ID" :rules="[{ required: true }]" required />
              <van-field v-if="accountIdInfo.accountType == 1" readonly clickable v-model="transferForm.tenFundTypeName" @click="showPicker('tenFundType','transferForm')" label="调出资金账号类型" placeholder="请选择调出的资金账号类型" :rules="[{ required: true }]" required />
              <van-field v-if="accountIdInfo.accountType == 1" readonly clickable v-model="transferForm.allotTenFundTypeName" @click="showPicker('allotTenFundType','transferForm')" label="调入资金账号类型" placeholder="请选择调入的资金账号类型" :rules="[{ required: true }]" required />
            </van-form>
          </template>

          <template v-if="accountIdInfo.contractId && type === 'refund'">
            <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">退款信息</van-divider>
            <van-form ref="refundForm" validate-trigger="onSubmit" class="refundForm" style="height: auto; overflow: hidden;">
              <template v-if="accountIdInfo.accountType === 2">
                <van-cell v-if="refundForm.deposit_amount" title="需预留保证金：" :value="refundForm.deposit_amount" />
                <van-cell v-if="refundForm.cash_transfer_balance || refundForm.cash_transfer_balance == 0" title="可转账户币余额：" :value="refundForm.cash_transfer_balance" />
              </template>
              <template v-if="accountIdInfo.accountType === 1">
                <van-cell v-for="(item, index) in tencentMapList" :key="index" :title="item.fundType" :value="item.balance" />
              </template>
              <van-cell v-if="refundForm.rechargeAmount" title="垫款未回款金额：" :value="refundForm.rechargeAmount" />
              <van-field v-model="refundForm.rechargeMoney" label="账户币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
              <van-field v-if="accountIdInfo.accountType == 1" readonly clickable v-model="refundForm.tenFundTypeName" @click="showPicker('tenFundType','refundForm')" label="资金账号类型" placeholder="请选择资金账号类型" :rules="[{ required: true }]" required />
              <van-field v-model="refundForm.refundUrl" label="客户截图" placeholder="请点击下方上传充值截图" :rules="[{ required: true }]" required readonly />
              <van-uploader class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
              <div style="color: #ff976a; font-size: 14px;">只能上传一张jpg/png格式图片，且不超过10mb</div>
              <van-field v-model="refundForm.refundReason" label="退款原因" placeholder="请输入退款原因" type="textarea" rows="5" :rules="[{ required: true }]" required />
            </van-form>
          </template>
          <div :class="accountIdInfo.contractId?type === 'recharge' || type === 'refund'?'footer':'footer2':'footer00'">
            <van-button hairline type="defaut" plain @click="visible = false; selectType()">取消</van-button>
            <template v-if="accountIdInfo.contractId">
              <template v-if="type === 'recharge'">
                <van-button hairline type="primary" plain @click="saveRecharge">媒介充值</van-button>
                <van-button v-if="rechargeForm.mediaRechargeType !== 2 && isOnLineType !== 1" hairline type="warning" plain @click="saveRechargeOnline">在线充值</van-button>
              </template>
              <van-button v-if="type === 'transfer' && allotAccountIdInfo.contractId" hairline type="warning" plain @click="saveTransfer">调拨</van-button>
              <van-button v-if="type === 'refund'" hairline type="warning" plain @click="beforeRefund('online')">在线退款</van-button>
              <van-button v-if="type === 'refund'" hairline type="info" plain @click="beforeRefund('medium')">媒介退款</van-button>
              <!-- <van-button v-if="type === 'refund'" hairline type="warning" plain @click="saveRefund('advances')">退款回垫款</van-button>
              <van-button v-if="type === 'refund'" hairline type="info" plain @click="saveRefund('imprest')">退款回备款</van-button> -->
            </template>
          </div>
        </van-dialog>

        <van-dialog v-model="refundVisible" :title="refundForm.isRefundMedium === 1?'媒介退款':'在线退款'" width="80%" :show-confirm-button="false" :closeOnClickOverlay="true">
          <div class="refund_button">
            <van-button type="warning" size="small" @click="saveRefund('advances')">退款回垫款 </van-button>
            <van-button type="info" size="small" @click="saveRefund('imprest')">退款回备款</van-button>
            <van-button type="default" size="small" @click="refundVisible = false">取 消</van-button>
          </div>
        </van-dialog>

        <!-- 绑定账户ID -->
        <van-dialog v-model="bindVisible" title="账户ID绑定" width="95%" style="height:70%" class="authId_dialog" :beforeClose="bindBeforeClose" show-cancel-button>
          <van-form ref="bindForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
            <van-field readonly clickable v-model="bindForm.contractName" @click="openSelect" label="合同信息" placeholder="请选择合同信息" :rules="[{ required: true }]" required />
            <van-field v-if="contractInfo.channelType && contractInfo.channelType != 1" v-model="bindForm.execCustomerName" label="执行客户"
              placeholder="请选择执行客户" readonly clickable @click="showPicker('execCustomer','bindForm')" :rules="[{ required: true }]" required />
            <van-field v-model="bindForm.projectName" label="项目名称" :disabled="contractInfo.channelType && contractInfo.channelType != 1 && !bindForm.execCustomerId"
              placeholder="请选择项目名称" readonly clickable  @click="showPicker('project','bindForm')" :rules="[{ required: true }]" required />
            <van-field v-model="bindForm.startDateStr" readonly clickable name="calendar" label="投放开始时间" placeholder="点击选择投放开始时间" @click="showCalendar('startDateStr','bindForm')" :rules="[{ required: true }]" required />
            <van-field v-model="bindForm.endDateStr" readonly clickable name="calendar" label="投放结束时间" placeholder="点击选择投放结束时间" @click="showCalendar('endDateStr','bindForm')" :rules="[{ required: true }]" required />
            <van-cell title="是否授权户" required>
              <template>
                <van-radio-group v-model="bindForm.consumeType" direction="horizontal">
                  <van-radio :name="1" clickable>常规户</van-radio>
                  <van-radio :name="2" clickable>授权户</van-radio>
                </van-radio-group>
              </template>
            </van-cell>
          </van-form>
        </van-dialog>
        <!-- 合同列表弹窗 -->
        <van-dialog v-model="selectVisible" width="97%" style="height: 80%;overflow: scroll;" title="选择合同" :showConfirmButton = 'false' :close-on-click-overlay="true">
          <van-search v-model="contQuery.contractName" placeholder="请输入合同名称搜索" @search="contSearch"/>
          <van-list v-model="contractLoading" :finished="finished" finished-text="没有更多了" @load="getContractList" v-if="contractList.length > 0">
            <van-cell-group v-for="(item,index) in contractList" :key="index" style="padding-bottom: 10px;">
              <div class="flex-c-center" v-if="item">
                <div style="flex: 1">
                  <div style="color: #666;font-size: 14px;padding: 10px 20px;line-height: 22px">
                    <div>合同编号：<span style="color: #333;">{{item.contractNum}}</span></div>
                    <div style="padding-left:70px;text-indent:-70px;">合同标题：<span style="color: #333;">{{item.contractName}}</span></div>
                    <div>主体机构：<span style="color: #333;">{{item.companyName}}</span></div>
                    <div>客户名称：<span style="color: #333;">{{item.custName}}</span></div>
                    <div>客户来源：<span style="color: #333;">{{ formatHandel("custSource",item.custSource) }}</span></div>
                    <div>执行时间：<span style="color: #333;">{{item.startTime}}至{{item.endTime}}</span></div>
                    <div>用户名称：<span style="color: #333;">{{item.userName}}</span></div>
                  </div>
                </div>
              </div>
              <van-button style="width: 30%;margin: 0 auto" size="mini" type="info" block @click="selectContract(item)">选择</van-button>
            </van-cell-group>
          </van-list>
          <empty v-if="contractList.length == 0" />
        </van-dialog>

        <!-- 充值结果 -->
        <van-dialog v-model="resultVisible" width="97%" :title="resultTitle" class="result_dialog" style="height: 86%;" show-cancel-button>
          <div style="height: 100%; overflow-y: scroll;">
            <template v-if="resultTitle === '充值结果'">
              <!-- <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">充值结果</van-divider> -->
              <van-list>
                <van-cell v-for="(item,index) in rechargeResultList" :key="index" style="padding: 6px">
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;">
                      <div class="td td2">账户币</div>
                      <div class="tb tb2" style="color: #ee0a24;">{{ item.rechargeMoney }}</div>
                    </div>
                    <div style="display: flex;width: 50%;">
                      <div class="td td2">现金金额</div>
                      <div class="tb tb2">{{ item.payMoney || '--' }}元</div>
                    </div>
                  </div>
                  <div class="table">
                    <div class="td">账户ID</div>
                    <div class="tb">{{ item.accountNo }}</div>
                  </div>
                  <div class="table">
                    <div class="td">账户名称</div>
                    <div class="tb">{{ item.accountName || '--' }}</div>
                  </div>
                  <div class="table" v-if="item.serviceId">
                    <div class="td">服务商ID</div>
                    <div class="tb">{{ item.serviceId }}</div>
                  </div>
                  <div class="table" v-if="item.subAccountId">
                    <div class="td">子账户ID</div>
                    <div class="tb">{{ item.subAccountId }}</div>
                  </div>
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;">
                      <div class="td td2">资金类型</div>
                      <div class="tb tb2">{{ formatHandel('fundType',item.fundType) }}</div>
                    </div>
                    <div style="display: flex;width: 50%;">
                      <div class="td td2">返点</div>
                      <div class="tb tb2">{{ item.percentage }}%</div>
                    </div>
                  </div>
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;">
                      <div class="td td2">充值状态</div>
                      <div class="tb tb2">
                        <span v-if="item.rechargeStatus == 1" style="color: #F56C6C">未充值</span>
                      <span v-if="item.rechargeStatus == 3" style="color: #E6A23C">驳回</span>
                        <span v-if="item.rechargeStatus == 2" style="color: #67C23A">已充值</span>
                        <span v-if="item.rechargeStatus == 4" style="color: #F56C6C">退款</span>
                      </div>
                    </div>
                    <div style="display: flex;width: 50%;">
                      <div class="td td2">是否在线充值</div>
                      <div class="tb tb2">
                        <span v-if="item.onLineType == 1" style="color: #F56C6C">否</span>
                        <span v-if="item.onLineType == 2" style="color: #F56C6C">是</span>
                      </div>
                    </div>
                  </div>
                  <div class="table" v-if="item.mediaTime">
                    <div class="td">充值时间</div>
                    <div class="tb">{{ item.mediaTime }}</div>
                  </div>
                  <div class="table" v-if="item.remark">
                    <div class="td">备注</div>
                    <div class="bz" style="color: #ee0a24">{{ item.remark }}</div>
                  </div>
                  <!-- <div class="flex-between">
                    <div style="color: #333; font-size: 12px">
                      <div>资金类型: {{ formatHandel('fundType',item.fundType) }}</div>
                      <div v-if="item.execCustomerName">执行客户: {{item.execCustomerName}} </div>
                      <template v-if="item.fundType == 1 || item.fundType == 2">
                        <div style="padding-left:50px; text-indent:-50px;">项目名称: {{`${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}} </div>
                        <div>账户名称: {{ item.accountName || '--' }}</div>
                        <div>账户ID: {{ item.accountNo }}</div>
                        <div>账户币: {{ item.rechargeMoney }}  &nbsp;&nbsp;&nbsp;&nbsp; 现金金额(元): {{ item.payMoney }}元</div>
                        <div v-if="item.serviceId">所属服务商ID: {{ item.serviceId }} <span v-if="item.subAccountId">子账户ID: {{ item.subAccountId }}</span></div>
                      </template>
                      <div>充值状态:
                        <span v-if="item.rechargeStatus == 1" style="color: #F56C6C">未充值</span>
                        <span v-if="item.rechargeStatus == 3" style="color: #E6A23C">驳回</span>
                        <span v-if="item.rechargeStatus == 2" style="color: #67C23A">已充值</span>
                        <span v-if="item.rechargeStatus == 4" style="color: #F56C6C">退款</span>
                      </div>
                      <template v-if="item.rechargeStatus == 2">
                        <div>媒介充值用户: {{item.mediaUserName}}</div>
                        <div>媒介充值时间: {{item.mediaTime}}</div>
                        <div v-if="item.mediaUrl">媒介充值图片:
                          <van-button type="info" size="mini" plain @click="showImg(item.mediaUrl)" v-if="item.mediaUrl">点击查看</van-button>
                        </div>
                      </template>
                      <div v-if="item.remark">备注: <span style="color: #ee0a24;">{{ item.remark }}</span></div>
                    </div>
                  </div> -->
                </van-cell>
              </van-list>
              <van-cell style="color: #ff976a;" :title="'注：如充值结果返回的充值状态是未充值，业务员可以到已申请的页面再次操作在线充值。'" />
            </template>

            <template v-if="resultTitle !== '充值结果'">
              <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">退款结果</van-divider>
              <van-list>
                <van-cell v-for="(item,index) in refundResultList" :key="index" style="padding: 6px">
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;">
                      <div class="td td2">退款账户币</div>
                      <div class="tb tb2" style="color: #ee0a24;">{{ item.rechargeMoney }}</div>
                    </div>
                    <div style="display: flex;width: 50%;">
                      <div class="td td2">退款金额</div>
                      <div class="tb tb2">{{ item.accountMoney || '--' }}元</div>
                    </div>
                  </div>
                  <div class="table">
                    <div class="td">账户ID</div>
                    <div class="tb">{{ item.accountId }}</div>
                  </div>
                  <div class="table" v-if="item.rechargeType !== 4">
                    <div class="td">账户名称</div>
                    <div class="tb">{{ item.corporationName || '--' }}</div>
                  </div>
                  <div class="table" v-if="item.serviceId">
                    <div class="td">服务商ID</div>
                    <div class="tb">{{ item.serviceId }}</div>
                  </div>
                  <div class="table" v-if="item.subAccountId">
                    <div class="td">子账户ID</div>
                    <div class="tb">{{ item.subAccountId }}</div>
                  </div>
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;">
                      <div class="td td2">退款状态</div>
                      <div class="tb tb2">
                        <span v-if="item.remark && item.remark.indexOf('退款成功') === -1" style="color: #ee0a24">退款失败</span>
                        <span v-else style="color: #67C23A">退款成功</span>
                      </div>
                    </div>
                    <div style="display: flex;width: 50%;" v-if="item.rechargeType !== 4">
                      <div class="td td2">返点</div>
                      <div class="tb tb2">{{ item.percentage }}%</div>
                    </div>
                  </div>
                  <!-- <div class="table">
                    <div class="td">退款状态：</div>
                    <div class="tb">
                      <span v-if="item.remark && item.remark.indexOf('退款成功') === -1" style="color: #ee0a24">退款失败</span>
                      <span v-else style="color: #67C23A">退款成功</span>
                    </div>
                  </div> -->
                  <div class="table" v-if="item.consumeDate">
                    <div class="td">退款时间</div>
                    <div class="tb">{{ item.consumeDate }}</div>
                  </div>
                  <div class="table" v-if="item.remark">
                    <div class="td">备注</div>
                    <div class="bz" style="color: #ee0a24">{{ item.remark }}</div>
                  </div>
                  <!-- <div class="flex-between">
                    <div style="color: #333; font-size: 12px">
                      <div>退款账户币: <span style="color: #ee0a24;">{{ item.rechargeMoney }}</span> &nbsp;&nbsp;&nbsp;&nbsp; 退款金额(元): {{ item.accountMoney || '--' }}元</div>
                      <div>账户ID: {{ item.accountId }}</div>
                      <div>账户名称: {{ item.corporationName || '--' }}</div>
                      <div v-if="item.serviceId">所属服务商ID: {{ item.serviceId }}</div>
                      <div v-if="item.subAccountId">子账户ID: {{ item.subAccountId }}</div>
                      <div>退款状态:
                        <span v-if="item.remark && item.remark.indexOf('退款成功') === -1" style="color: #F56C6C">退款失败</span>
                        <span v-else style="color: #67C23A">退款成功</span>
                      </div>
                      <div>返点: {{ item.projectId }}%</div>
                      <template v-if="item.rechargeType !== 3 && item.rechargeType !== 4">
                        <div>充值类型:
                          <span v-if="item.parentRechargeType === 1">预充值(收款)</span>
                          <span v-if="item.parentRechargeType === 3">垫款充值</span>
                          &nbsp;&nbsp;&nbsp;&nbsp; 可退现金金额: {{ item.parentRefundAllotBalance }}</div>
                        <div>已充值账户币: {{ item.parentRechargeMoney }}  &nbsp;&nbsp;&nbsp;&nbsp; 已充值现金金额(元): {{ item.parentAccountMoney }}元</div>
                      </template>
                      <div v-else>充值信息: {{ item.notes }}</div>
                      <template v-if="item.rechargeType !== 4">
                        <div>退款时间: {{ item.consumeDate || '--' }} </div>
                        <div v-if="item.rechargeType === 3">退款操作人: {{ item.deptName }}<span style="color: #409EFF">{{ item.userName }}</span></div>
                        <template v-if="item.rechargeType === 1 || item.rechargeType === 2 || item.rechargeType === 5">
                          <div>退款操作人: {{ item.mediaDeptName }}<span style="color: #409EFF">{{ item.mediaUserName }}</span></div>
                          <div>已充值操作人: {{ item.parentDeptName }}<span style="color: #409EFF">{{ item.parentMediaUserName }}</span></div>
                          <div>已充值日期: {{ item.parentConsumeDate }}</div>
                        </template>
                      </template>
                      <div v-if="item.remark">备注: <span style="color: #ee0a24">{{ item.remark }}</span></div>
                    </div>
                  </div> -->
                </van-cell>
              </van-list>
            </template>
            <template v-if="resultTitle === '调拨结果'">
              <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">充值结果</van-divider>
              <van-list>
                <van-cell v-for="(item,index) in rechargeResultList" :key="index" style="padding: 6px">
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;">
                      <div class="td td2">账户币</div>
                      <div class="tb tb2" style="color: #ee0a24;">{{ item.rechargeMoney }}</div>
                    </div>
                    <div style="display: flex;width: 50%;">
                      <div class="td td2">现金金额</div>
                      <div class="tb tb2">{{ item.payMoney || '--' }}元</div>
                    </div>
                  </div>
                  <div class="table">
                    <div class="td">账户ID</div>
                    <div class="tb">{{ item.accountNo }}</div>
                  </div>
                  <div class="table" v-if="item.rechargeType !== 4">
                    <div class="td">账户名称</div>
                    <div class="tb">{{ item.corporationName || '--' }}</div>
                  </div>
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;" v-if="item.serviceId">
                      <div class="td td2">服务商ID</div>
                      <div class="tb tb2">{{ item.serviceId }}</div>
                    </div>
                    <div style="display: flex;width: 50%;" v-if="item.subAccountId">
                      <div class="td td2">子账户ID</div>
                      <div class="tb tb2">{{ item.subAccountId }}%</div>
                    </div>
                  </div>
                  <div class="table">
                    <div style="display: flex;border-right: 1px solid #ddd;width: 50%;">
                      <div class="td td2">充值状态</div>
                      <div class="tb tb2">
                        <span v-if="item.rechargeStatus == 1" style="color: #F56C6C">未充值</span>
                      <span v-if="item.rechargeStatus == 3" style="color: #E6A23C">驳回</span>
                        <span v-if="item.rechargeStatus == 2" style="color: #67C23A">已充值</span>
                        <span v-if="item.rechargeStatus == 4" style="color: #F56C6C">退款</span>
                      </div>
                    </div>
                    <div style="display: flex;width: 50%;" v-if="item.rechargeType !== 4">
                      <div class="td td2">返点</div>
                      <div class="tb tb2">{{ item.percentage }}%</div>
                    </div>
                  </div>
                  <div class="table" v-if="item.mediaTime">
                    <div class="td">充值时间</div>
                    <div class="tb">{{ item.mediaTime }}</div>
                  </div>
                  <div class="table" v-if="item.remark">
                    <div class="td">备注</div>
                    <div class="bz" style="color: #ee0a24">{{ item.remark }}</div>
                  </div>
                  <!-- <div class="flex-between">
                    <div style="color: #333; font-size: 12px">
                      <div>退款账户币: <span style="color: #ee0a24;">{{ item.refundRechargeMoney }}</span> &nbsp;&nbsp;&nbsp;&nbsp; 退款金额(元): {{ item.refundPayMoney || '--' }}元</div>
                      <div>退款时间: {{ item.refundTime || '--' }} </div>
                      <div>充值状态:
                        <span v-if="item.rechargeStatus == 1" style="color: #F56C6C">未充值</span>
                        <span v-if="item.rechargeStatus == 3" style="color: #E6A23C">驳回</span>
                        <span v-if="item.rechargeStatus == 2" style="color: #67C23A">已充值</span>
                        <span v-if="item.rechargeStatus == 4" style="color: #F56C6C">退款</span>
                      </div>
                      <div v-if="item.contNewIncomeDetailExecId">
                        充值类型:
                        <span v-if="item.rechargeType === 1">预充值(收款)</span>
                        <span v-if="item.rechargeType === 3">垫款充值</span>
                      </div>
                      <div v-else>充值信息: {{ item.notes }}</div>
                      <div v-if="item.rechargeStatus == 2">可退现金金额: {{ item.refundAllotBalance }}</div>
                      <div>返点: {{ item.percentage }}%</div>
                      <div>账户币: <span style="color: #ee0a24;">{{ item.rechargeMoney }}</span>  &nbsp;&nbsp;&nbsp;&nbsp; 现金金额(元): {{ item.payMoney }}元</div>
                      <div>账户ID: {{ item.accountNo }} &nbsp;&nbsp;&nbsp;&nbsp; 账户名称: {{ item.corporationName || '--' }}</div>
                      <div v-if="item.serviceId">所属服务商ID: {{ item.serviceId }} <span v-if="item.subAccountId">子账户ID: {{ item.subAccountId }}</span></div>

                      <div>退款操作人: {{ item.consumeDeptName }}<span style="color: #409EFF">{{ item.consumeUserName }}</span></div>
                      <div>充值操作人: {{ item.mediaDeptName }}<span style="color: #409EFF">{{ item.mediaUserName }}</span></div>
                      <div v-if="item.mediaTime">充值时间: {{ item.mediaTime }}</div>
                      <div v-if="item.remark">备注: <span style="color: #ee0a24;">{{ item.remark }}</span></div>
                    </div>
                  </div> -->
                </van-cell>
              </van-list>
            </template>
          </div>
          <div :class="accountType !== 2?'footer00':resultTitle === '退款结果'?'footer':'footer2'">
            <van-button hairline type="defaut" plain @click="resultVisible = false;">关闭</van-button>
            <van-button v-if="resultTitle === '退款结果'" hairline type="warning" plain @click="continueRefund">继续退款</van-button>
            <van-button v-if="accountType === 2" hairline type="info" plain @click="viewCredentials">凭证</van-button>
          </div>
        </van-dialog>

        <!-- 请选择所属服务商ID -->
        <van-dialog v-model="serviceIdVisible" title="请选择所属服务商ID" width="95%" style="height:30%" class="serviceId" :beforeClose="saveServiceId">
          <van-form ref="serviceIdForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
            <van-field readonly clickable v-model="refundServiceName" @click="showPicker('serviceId','refundServiceId')" label="所属服务商ID" placeholder="请选择所属服务商ID" :rules="[{ required: true }]" required />
          </van-form>
        </van-dialog>
        <!-- 退款结果 -->
        <!-- <van-dialog v-model="resultVisible" class="contract" width="97%" style="height: 80%;overflow: scroll;" title="退款结果" :showConfirmButton = 'false' :close-on-click-overlay="true">
          <van-list style="height: 60%">
            <van-cell v-for="(item,index) in refundResultList" :key="index">
              <div class="flex-between">
                <div style="color: #333; font-size: 12px">
                  <div>退款账户币: {{ item.rechargeMoney }} &nbsp;&nbsp;&nbsp;&nbsp; 退款金额(元)：: {{ item.accountMoney || '--' }}元</div>
                  <div>退款时间: {{ item.consumeDate || '--' }} </div>
                  <div>退款状态:
                    <span v-if="item.remark" style="color: #F56C6C">退款失败</span>
                    <span v-else style="color: #67C23A">退款成功</span>
                  </div>
                  <template v-if="item.rechargeType !== 3 && item.rechargeType !== 4">
                    <div>充值类型:
                      <span v-if="item.parentRechargeType === 1">预充值(收款)</span>
                      <span v-if="item.parentRechargeType === 3">垫款充值</span>
                      &nbsp;&nbsp;&nbsp;&nbsp; 可退账户币：: {{ item.parentRefundAllotBalance }}</div>
                    <div>账户币: {{ item.parentAccountMoney }}  &nbsp;&nbsp;&nbsp;&nbsp; 现金金额(元)：: {{ item.parentRechargeMoney }}元</div>

                  </template>
                  <div v-else>充值信息: {{ item.notes }}</div>
                  <template v-if="item.rechargeType !== 3">
                    <div>账户ID: {{ item.accountNo }} &nbsp;&nbsp;&nbsp;&nbsp; 账户名称：: {{ item.corporationName || '--' }}</div>
                    <div v-if="item.serviceId">所属服务商ID: {{ item.serviceId }} <span v-if="item.subAccountId">子账户ID: {{ item.subAccountId }}</span></div>
                  </template>
                  <template v-if="item.rechargeType !== 4">
                    <div v-if="item.rechargeType === 3">退款操作人: {{ item.deptName }}<span style="color: #409EFF">{{ item.userName }}</span></div>
                    <template v-if="item.rechargeType === 1 || item.rechargeType === 2">
                      <div>退款操作人： {{ item.mediaDeptName }}<span style="color: #409EFF">{{ item.mediaUserName }}</span></div>
                      <div>已充值操作人： {{ item.parentDeptName }}<span style="color: #409EFF">{{ item.parentMediaUserName }}</span></div>
                      <div>已充值日期: {{ item.parentConsumeDate }}</div>
                    </template>
                  </template>
                  <div v-if="item.remark">失败原因: {{ item.remark }}</div>
                </div>
              </div>
            </van-cell>
          </van-list>
        </van-dialog> -->

        <!-- 巨量账户ID绑定提示 -->
        <van-dialog v-model="jlTipVisible" title="账户ID绑定提示" width="95%" style="height:36%" class="editClue" show-cancel-button>
          <van-cell style="color: #F56C6C;" :title="`${jlResult.advertiserName}主体有${jlResult.accountIdNoContract}个未绑定的账户ID，请前往绑定项目。`" />
          <template v-if="jlResult.isOneTouchBind == 1">
            <van-field v-model="jlResult.startDateStr" readonly clickable name="calendar" label="投放开始时间" placeholder="点击选择投放开始时间" @click="showCalendar('startDateStr','jlResult')" :rules="[{ required: true }]" required />
            <van-field v-model="jlResult.endDateStr" readonly clickable name="calendar" label="投放结束时间" placeholder="点击选择投放结束时间" @click="showCalendar('endDateStr','jlResult')" :rules="[{ required: true }]" required />
          </template>
          <van-cell v-if="jlResult.isOneTouchBind == 2" style="color: #ff976a;" :title="'注：该合同/执行客户存在多个项目，请前往（PC端）至 账户ID查询页绑定。'" />
          <div :class="jlResult.isOneTouchBind == 1?'footer2':'footer00'">
            <van-button hairline type="defaut" plain :disabled="countdown > 0" @click="jlTipVisible = false">跳过<span v-if="countdown > 0">（{{ countdown }}）</span></van-button>
            <van-button v-if="jlResult.isOneTouchBind == 1" hairline type="primary" plain @click="oneClickBinding">一键绑定</van-button>
          </div>
        </van-dialog>

        <van-popup v-model="picker.visible" position="bottom">
          <van-search v-model="queryAccountId" placeholder="请输入子账户ID查询" @search="searchSubAccountId" @input="searchSubAccountId" v-if="picker.formKey == 'subAccountId'" />
          <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
        </van-popup>
        <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" />

        <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>

      </div>
    </div>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
import advances from '@/api/channel/advances'
import newContract from '@/api/cont/newContract'
import { Toast, Dialog, ImagePreview, Checkbox, CheckboxGroup } from 'vant'
import { getValue } from '@/utils/util'
import ProjectPointDetail from '@/views/cont/components/ProjectPointDetail'
import Empty from '@/components/common/Empty'
export default {
  components: {
    Empty,
    ProjectPointDetail,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  watch: {

  },
  data() {
    return {
      visible: false,
      type: 'recharge',
      activeNames: ['1'],
      fromPage: null,
      accountId: null,
      accountIdInfo: {},
      rechargeForm: {},
      isOnLineType: 0,
      paymentList: [],
      chooseList: [],
      dataType: 1,

      transferForm: {},
      fromForm: null,
      allotAccountId: null,
      allotAccountIdInfo: {},

      refundVisible: false,
      refundForm: {},
      pictureList: [],
      serviceIdVisible: false,
      refundServiceId: null,
      refundServiceName: null,
      continueRefundUrl: null,
      continueRefundReason: null,

      serviceIdList: [],
      queryAccountId: null,
      subAccountIdList: [],

      tencentMapList: [],
      options: {
        creditCycleTypeOptions: [], // 授信周期类型
        advancesTypeOptions: [],
        fundTypeOptions: [],
        tenFundTypeOptions: []
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        form: '',
        formKey: '',
        loading: false
      },
      datePicker: {
        form: null,
        showDate: false,
        minDate: new Date(2023, 0, 1),
        type: 'single',
        formKey: ''
      },
      imageShow: false,
      imageArr: [],

      selectVisible: false,
      contQuery: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        isAccountId: 1,
        accountType: null,
        contractId: null,
        contractName: null,
        isPayment: true
      },
      finished: false,
      contractLoading: true,
      contractList: [],
      contractInfo: {},
      bindVisible: false,
      bindForm: {
        isTransfer: 1,
        contractId: null,
        contractName: null,
        execCustomerId: null,
        execCustomerName: null,
        projectId: null,
        projectName: null,
        consumeType: 1,
        startDateStr: null,
        endDateStr: null,
        accountIds: null
      },

      resultTitle: null,
      resultVisible: false,
      rechargeResultList: [],
      refundResultList: [],

      accountType: null,

      // 巨量账户ID绑定提示
      jlTipVisible: false,
      countdown: 3,
      jlResult: {},
      jlDateRange: []
    }
  },
  async created() {
    await this.getOptions()
  },
  mounted() {

  },
  methods: {
    openVisible(type, fromPage) {
      if (type) {
        this.type = type
      }
      if (fromPage) {
        this.fromPage = fromPage
      }
      this.visible = true
    },
    selectType() {
      this.rechargeForm = {}
      this.transferForm = {}
      this.refundForm = {}
      this.pictureList = []
      this.accountIdInfo = {}
      this.allotAccountIdInfo = {}

      this.continueRefundUrl = null
      this.continueRefundReason = null
    },
    // 弹出选择合同列表
    openSelect() {
      this.getContractList()
      this.selectVisible = true
    },
    async getContractList() {
      this.contractLoading = true
      await newContract.getConContractExportList(this.contQuery).then(res => {
        if (res.code == 200) {
          this.contractList = this.contractList.concat(...res.rows)
          this.contQuery.pageNum += 1
          this.finished = this.contractList.length >= res.total
          this.contractLoading = false
        }
      })
    },
    queryContractList() {
      this.contQuery.pageNum = 1
      this.pageSize = 10
      this.getContractList()
    },
    async contSearch() {
      this.contractList = []
      await this.queryContractList()
      // this.contractList = this.contractList.filter(item => {
      //   return item.contractName.indexOf(this.contQuery.contractName) > -1 || item.contractNum.indexOf(this.contQuery.contractName) > -1
      // })
      // console.log(this.contractList)
      // this.picker.columns = this.contractList.map((ele) => ele.contractNum + '  ' + ele.contractName)
    },
    // date 代表指定的日期，格式：2023-09-27
    // day 传-1表始前一天，传1表始后一天
    getNextDate(day) {
      var dd = new Date()
      dd.setDate(dd.getDate() + day)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
      return y + '-' + m + '-' + d
    },
    async selectContract(row) {
      this.bindForm.execCustomerId = null
      this.bindForm.execCustomerName = null
      this.bindForm.projectId = null
      this.bindForm.projectName = null
      this.contractInfo = row
      this.bindForm.contractName = row.contractName
      this.bindForm.contractId = row.contractId
      this.bindForm.startDateStr = this.getNextDate(0)
      this.bindForm.endDateStr = row.endTime
      if (row.channelType == 1) {
        await this.getProjectList(1, row.contractId)
      } else {
        await payment.listExecutive({ contractId: row.contractId, channelType: row.channelType }).then(res => {
          if (res.code == 200) {
            this.execCustomerList = res.rows
          }
        })
        if (this.execCustomerList.length === 1) {
          this.bindForm.execCustomerId = this.execCustomerList[0].execCustomerId
          this.bindForm.execCustomerName = this.execCustomerList[0].execCustomerName
          await this.getProjectList(2, this.bindForm.execCustomerId)
        }
      }
      this.selectVisible = false
    },
    // 获取项目名称列表
    async getProjectList(type, id) {
      await newContract.listProjectPercentage({ bussType: type, bussId: id }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
          if (this.projectList.length === 1) {
            this.bindForm.projectId = this.projectList[0].projectId
            this.bindForm.projectName = this.projectList[0].projectName
          }
        }
      })
    },
    // 绑定账户ID
    async bindBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.bindForm.validate()
          const res = await payment.addAssociationFront(this.bindForm)
          if (res.code === 200) {
            if (res.data.prompt) {
              Dialog.confirm({
                confirmButtonText: '继续',
                message: '<span style="color: #E6A23C;">提示（注：绑错合同并充值的，依据制度经办人成长200元/笔，请认真核查。）</span>\n' + res.data.prompt
              })
                .then(async () => {
                  await this.addAssociation(res.data.association)
                  done()
                })
            } else {
              await this.addAssociation(res.data.association)
              done()
            }
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    async addAssociation(data) {
      await payment.addAssociation(data).then(response => {
        if (response.code === 200) {
          Toast.success('账户ID绑定成功')
          this.bindVisible = false
          this.bindForm = {
            isTransfer: 1,
            contractId: null,
            contractName: null,
            execCustomerId: null,
            execCustomerName: null,
            projectId: null,
            projectName: null,
            consumeType: 1,
            startDateStr: null,
            endDateStr: null,
            accountIds: null
          }
          setTimeout(async() => {
            await this.onSearch()
            await this.onSearchTransfer()
          }, 1500)
        } else {
          Toast.fail(response.msg)
        }
      })
    },
    async onSearch() {
      if (!this.accountId) {
        Toast.fail('请先输入账户ID')
        return
      }
      const queryData = {}
      if (this.type === 'transfer' || this.type === 'refund') {
        queryData.accountId = this.accountId
        queryData.refundType = 2
      } else {
        queryData.accountId = this.accountId
        queryData.refundType = null
      }
      await advances.getRechargeFront(queryData).then(async (res) => {
        if (res.code === 200) {
          if (this.type === 'recharge' && res.data.accountType === 2 && res.data.serviceId) {
            const params = {
              contractId: res.data.contractId,
              execCustomerId: res.data.execCustomerId,
              projectId: res.data.projectId,
              accountId: this.accountId
            }
            await advances.getRechargeBind(params).then(jlres => {
              if (jlres.code === 200) {
                if (jlres.data.isBind === 1) {
                  this.jlResult = jlres.data
                  if (jlres.data.startDateStr && jlres.data.endDateStr) {
                    this.jlDateRange = [jlres.data.startDateStr, jlres.data.endDateStr]
                  }
                  this.jlTipVisible = true
                  this.countdown = 3
                  const timeClock = setInterval(() => {
                    this.countdown--
                    if (this.countdown === 0) {
                      clearInterval(timeClock)
                    }
                  }, 1000)
                }
              }
            })
          }
          this.accountIdInfo = res.data
          this.accountType = this.accountIdInfo.accountType
          // console.log(this.$refs.projectPointDetail)
          if (this.accountIdInfo.execCustomerId) {
            await this.$refs.projectPointDetail.getProjectList(2, this.accountIdInfo.execCustomerId, this.accountIdInfo.execCustomerName, this.accountIdInfo.agentBusinessMoney, this.accountIdInfo.projectId)
          } else {
            await this.$refs.projectPointDetail.getProjectList(1, this.accountIdInfo.contractId, '', '', this.accountIdInfo.projectId)
          }
          if (this.type === 'recharge') {
            this.rechargeForm = {
              deposit_amount: null,
              cash_transfer_balance: null,
              accountId: null,
              serviceId: null,
              rechargeMoney: null,
              payMoney: null,
              mediaRechargeType: 1,
              tenFundType: this.accountIdInfo.accountType == 1 ? 'FUND_TYPE_CASH' : null,
              tenFundTypeName: this.accountIdInfo.accountType == 1 ? '现金账户' : null,
              subAccountId: null,
              rechargeRemainMoney: null
            }
            this.rechargeForm.serviceId = this.accountIdInfo.serviceId || null
            this.rechargeForm.serviceName = this.accountIdInfo.serviceId || null
            if (this.accountIdInfo.accountType === 1) {
              await this.getAccountMediaRechargeType()
            }
            await this.getPaymentList()
            await this.getAccountBalance('rechargeForm')
          }
          if (this.type === 'transfer') {
            this.transferForm = {
              deposit_amount: null,
              cash_transfer_balance: null,
              serviceId: null,
              allotServiceId: null,
              allotServiceName: null,
              tenFundType: this.accountIdInfo.accountType == 1 ? 'FUND_TYPE_CASH' : null,
              tenFundTypeName: this.accountIdInfo.accountType == 1 ? '现金账户' : null,
              allotTenFundType: this.accountIdInfo.accountType == 1 ? 'FUND_TYPE_CASH' : null,
              allotTenFundTypeName: this.accountIdInfo.accountType == 1 ? '现金账户' : null,
              subAccountId: null,
              isSameRebate: 2,
              isCrossCont: 2,
              mediaRechargeType: 1,
              refundType: 2,
              accountId: null,
              accountType: null,
              rechargeMoney: null
            }
            await this.getAccountBalance('transferForm')
          }
          if (this.type === 'refund') {
            this.refundForm = {
              deposit_amount: null,
              cash_transfer_balance: null,
              rechargeAmount: null,
              serviceId: null,
              tenFundType: this.accountIdInfo.accountType == 1 ? 'FUND_TYPE_CASH' : null,
              tenFundTypeName: this.accountIdInfo.accountType == 1 ? '现金账户' : null,
              refundType: 1,
              accountId: null,
              accountType: null,
              refundUrl: this.continueRefundUrl || null,
              refundReason: this.continueRefundReason || null
            }
            await this.getAccountBalance('refundForm')
            await advances.getRechargeAmount({ contractId: res.data.contractId, execCustomerId: res.data.execCustomerId }).then(res => {
              if (res.code === 200) {
                this.refundForm.rechargeAmount = res.data
              }
            })
          }
          await this.getContTencentAccountTokenList(this.accountIdInfo.accountType)
        } else {
          this.accountIdInfo = {}
          Toast.fail(res.msg)
          setTimeout(async() => {
            this.bindVisible = true
            this.bindForm.accountIds = this.accountId
          }, 1500)
        }
      })
    },
    // 巨量一键绑定
    async oneClickBinding() {
      const res = await payment.addAssociationFront(this.jlResult)
      if (res.code === 200) {
        if (res.data.prompt) {
          Dialog.confirm({
            confirmButtonText: '继续',
            message: '<span style="color: #E6A23C;">提示（注：绑错合同并充值的，依据制度经办人成长200元/笔，请认真核查。）</span>\n' + res.data.prompt
          })
            .then(async () => {
              await this.jlAssociation(res.data.association)
            })
        } else {
          await this.jlAssociation(res.data.association)
        }
      }
    },
    jlAssociation(data) {
      payment.addAssociation(data).then(response => {
        if (response.code === 200) {
          // Toast.success(response.data.failureMsg)
          Toast.success('账户ID绑定成功')
          this.jlTipVisible = false
        } else {
          Toast.fail(response.msg)
        }
      })
    },
    async getAccountMediaRechargeType() {
      await advances.getAccountMediaRechargeType({ accountId: this.accountId, accountType: this.accountIdInfo.accountType }).then(res => {
        if (res.code === 200) {
          this.isOnLineType = res.data.type
          if (res.data.serviceId) {
            this.rechargeForm.mediaRechargeType = 2
            this.rechargeForm.subAccountId = res.data.serviceId
            this.rechargeForm.subAccountName = res.data.serviceId
          }
        }
      })
    },
    async onSearchTransfer() {
      if (!this.allotAccountId) {
        // Toast.fail('请先输入调入账户ID')
        return
      }
      await advances.getRechargeFront({ accountId: this.allotAccountId, refundType: 2 }).then(async (res) => {
        if (res.code === 200) {
          if (this.accountIdInfo.accountType !== res.data.accountType) {
            Toast.fail('调出账户ID与调入账户ID平台不一致，不允许跨平台调拨')
            return
          }
          this.allotAccountIdInfo = res.data
          if (this.allotAccountIdInfo.execCustomerId) {
            await this.$refs.projectPointTransfer.getProjectList(2, this.allotAccountIdInfo.execCustomerId, this.allotAccountIdInfo.execCustomerName, this.allotAccountIdInfo.agentBusinessMoney, this.allotAccountIdInfo.projectId)
          } else {
            await this.$refs.projectPointTransfer.getProjectList(1, this.allotAccountIdInfo.contractId, '', '', this.allotAccountIdInfo.projectId)
          }
          this.transferForm.allotServiceId = this.allotAccountIdInfo.serviceId || null
          this.transferForm.allotServiceName = this.allotAccountIdInfo.serviceId || null
        } else {
          this.allotAccountIdInfo = {}
          Toast.fail(res.msg)
          setTimeout(async() => {
            this.bindVisible = true
            this.bindForm.accountIds = this.allotAccountId
          }, 1500)
        }
      })
    },
    // 获取认领/垫款信息列表
    async getPaymentList() {
      await advances.getClaimRecord({ dataType: this.dataType, contractId: this.accountIdInfo.contractId, execCustomerId: this.accountIdInfo.execCustomerId, accountType: this.accountIdInfo.accountType, projectId: this.accountIdInfo.projectId }).then(res => {
        if (res.code == 200) {
          this.paymentList = res.data
          this.chooseList = res.data
          this.rechargeForm.rechargeRemainMoney = this.chooseList.reduce((total, item) => total + Number(item.rechargeRemainMoney), 0)
        }
      })
    },
    selectDataType(val) {
      if (val) {
        this.getPaymentList()
      }
    },
    toggleAll() {
      this.$refs.checkboxGroup.toggleAll()
    },
    async getAccountBalance(form) {
      let id = null
      let serviceId = null
      if (form === 'rechargeForm') {
        console.log(this.rechargeForm.serviceId)
        id = this.rechargeForm.serviceId || this.accountIdInfo.serviceId || this.refundServiceId
        serviceId = this.rechargeForm.serviceId || this.accountIdInfo.serviceId || this.refundServiceId
      } else {
        id = this.accountId
        serviceId = this.accountIdInfo.serviceId || this.refundServiceId
      }
      await advances.getAccountBalance({ accountId: id, accountType: this.accountIdInfo.accountType, serviceId: serviceId }).then(res => {
        if (res.code === 200) {
          this[form].deposit_amount = res.data.deposit_amount
          this[form].cash_transfer_balance = res.data.cash_transfer_balance
          this[form].serviceId = res.data.serviceId
          this[form].serviceName = res.data.serviceId
          if (this.accountIdInfo.accountType === 1) {
            this.tencentMapList = res.data.mapList
          }
        } else if (res.msg === '请选择所属服务商ID' || res.msg === '广告账户ID不能为空') {
          Toast.fail(res.msg)
          setTimeout(async() => {
            this.fromForm = form
            this.refundServiceId = null
            this.serviceIdVisible = true
          }, 1500)
        }
      })
    },
    async saveServiceId(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.serviceIdForm.validate()
          this.refundForm.serviceId = this.refundServiceId
          await this.getAccountBalance(this.fromForm)
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    async getContTencentAccountTokenList(accountType) {
      await payment.getContTencentAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.serviceIdList = res.data
        }
      })
      await payment.getSubAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.subAccountIdList = res.data
        }
      })
      if (accountType === 1) {
        await this.getDicts('finance_account_type').then(res => {
          this.options.tenFundTypeOptions = res.data
        })
      }
    },
    async searchSubAccountId() {
      await payment.getSubAccountTokenList({ accountType: this.accountIdInfo.accountType }).then(res => {
        if (res.code === 200) {
          this.subAccountIdList = res.data
        }
      })
      this.subAccountIdList = this.subAccountIdList.filter(item => {
        return (item.accountId.toString()).indexOf(this.queryAccountId) > -1
      })
      this.picker.columns = this.subAccountIdList.map((ele) => ele.accountId + '  ' + ele.remark)
    },
    // 获取账户币和充值金额
    async getPayMoney(type, val, form) {
      let fundType = null
      // if (this.accountIdInfo.projectName.indexOf('自运营') > -1 || this.accountIdInfo.projectName.indexOf('品牌单') > -1) {
      //   fundType = 2
      // } else if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
      //   fundType = 1
      // }
      if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
        fundType = 1
      } else {
        fundType = 2
      }
      const params = {
        payMoney: null,
        rechargeMoney: null,
        fundType: fundType,
        projectId: this.accountIdInfo.projectId,
        contractId: this.accountIdInfo.contractId
      }
      if (type == 'payMoney') {
        this[form].rechargeMoney = null
        params.payMoney = val
        params.rechargeMoney = null
        await channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this[form].rechargeMoney = res.data
          }
        })
      } else if (type == 'rechargeMoney') {
        this[form].payMoney = null
        params.payMoney = null
        params.rechargeMoney = val
        await channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this[form].payMoney = res.data
          }
        })
      }
    },

    checkChange() {
      this.rechargeForm.rechargeRemainMoney = this.chooseList.reduce((total, item) => total + Number(item.rechargeRemainMoney), 0)
    },
    // 在线充值
    saveRechargeOnline() {
      this.rechargeForm.onLineType = 2
      this.addRecharge()
    },
    // 媒介充值
    saveRecharge() {
      this.rechargeForm.onLineType = 1
      this.addRecharge()
    },
    async addRecharge() {
      if (this.chooseList.length === 0) {
        Toast.fail('请勾选收款或垫款信息')
        return
      }
      await this.getDicts('sys_money_type').then(res => {
        this.options.fundTypeOptions = this.setDictToInt(res)
      })
      this.rechargeForm.accountId = this.accountId
      this.rechargeForm.accountType = this.accountIdInfo.accountType
      this.rechargeForm.dataType = this.paymentList[0].dataType
      // if (this.accountIdInfo.projectName.indexOf('自运营') > -1 || this.accountIdInfo.projectName.indexOf('品牌单') > -1) {
      //   this.rechargeForm.fundType = 2
      // } else if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
      //   this.rechargeForm.fundType = 1
      // }
      if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
        this.rechargeForm.fundType = 1
      } else {
        this.rechargeForm.fundType = 2
      }
      this.rechargeForm.contractId = this.accountIdInfo.contractId
      this.rechargeForm.execCustomerId = this.accountIdInfo.execCustomerId
      this.rechargeForm.projectId = this.accountIdInfo.projectId
      if (this.chooseList.length > 0 && this.rechargeForm.dataType === 1) {
        this.rechargeForm.detailList = this.chooseList
      } else if (this.chooseList.length > 0 && this.rechargeForm.dataType === 2) {
        this.rechargeForm.needDetailList = this.chooseList
      } else if (this.chooseList.length > 0 && this.rechargeForm.dataType === 3) {
        this.getDicts('money_type_advances').then(res => {
          this.options.fundTypeOptions = this.setDictToInt(res)
        })
        this.rechargeForm.advancesList = this.chooseList
      } else if (this.chooseList.length > 0 && this.rechargeForm.dataType === 5) {
        this.rechargeForm.imprestList = this.chooseList
      }
      await this.$refs.rechargeForm.validate()
      await advances.addRecharge(this.rechargeForm).then(res => {
        if (res.code == 200) {
          if (this.rechargeForm.onLineType === 1) {
            if (res.data.mediaUserName) {
              // Toast.success('充值申请成功,当前媒介排班人员为：' + res.data.mediaUserName)
              Dialog.alert({
                message: '充值申请成功,当前媒介排班人员为：' + res.data.mediaUserName
              }).then(() => {
              // on close
              })
              this.selectType()
              this.visible = false
              setTimeout(async() => {
                if (this.$parent.$root._route.path === '/channel/recharge/rechargeApplication') { this.$parent.queryCustList() }
              }, 1500)
            } else {
              Toast.fail('当前时段内未查询到排班人员，请指定媒介人员进行充值')
              this.selectType()
              this.visible = false
              setTimeout(async() => {
                if (this.$parent.$root._route.path === '/channel/recharge/rechargeApplication') { this.$parent.queryCustList() }
              }, 1500)
            }
          }
          if (this.rechargeForm.onLineType === 2) {
            if (res.data) {
              Toast.success('充值申请成功')
              this.selectType()
              this.visible = false
              this.resultTitle = '充值结果'
              this.resultVisible = true
              this.rechargeResultList = res.data
              setTimeout(async() => {
                if (this.$parent.$root._route.path === '/channel/recharge/rechargeApplication') { this.$parent.queryCustList() }
              }, 1500)
            }
          }
          this.accountId = null
        } else {
          Toast.fail(res.msg)
        }
      })
    },

    // 调拨
    async saveTransfer() {
      this.transferForm.accountId = this.accountId
      this.transferForm.accountType = this.accountIdInfo.accountType
      this.transferForm.contractId = this.accountIdInfo.contractId
      this.transferForm.execCustomerId = this.accountIdInfo.execCustomerId
      this.transferForm.projectId = this.accountIdInfo.projectId
      this.transferForm.percentage = this.accountIdInfo.percentage

      this.transferForm.allotAccountId = this.allotAccountId
      this.transferForm.allotContractId = this.allotAccountIdInfo.contractId
      this.transferForm.allotExecCustomerId = this.allotAccountIdInfo.execCustomerId
      this.transferForm.allotProjectId = this.allotAccountIdInfo.projectId
      this.transferForm.allotPercentage = this.allotAccountIdInfo.percentage
      // if (this.transferForm.serviceId !== this.transferForm.allotServiceId && this.accountIdInfo.accountType !== 2) {
      //   Toast.fail('调出账户ID与调入账户ID的所属服务商不一致，不允许调拨')
      //   return
      // }
      // if (this.accountIdInfo.projectName.indexOf('自运营') > -1 || this.accountIdInfo.projectName.indexOf('品牌单') > -1) {
      //   this.transferForm.fundType = 2
      // } else if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
      //   this.transferForm.fundType = 1
      // }
      if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
        this.transferForm.fundType = 1
      } else {
        this.transferForm.fundType = 2
      }
      // if (this.allotAccountIdInfo.projectName.indexOf('自运营') > -1 || this.allotAccountIdInfo.projectName.indexOf('品牌单') > -1) {
      //   this.transferForm.allotFundType = 2
      // } else if (this.allotAccountIdInfo.projectName.indexOf('代运营') > -1) {
      //   this.transferForm.allotFundType = 1
      // }
      if (this.allotAccountIdInfo.projectName.indexOf('代运营') > -1) {
        this.transferForm.allotFundType = 1
      } else {
        this.transferForm.allotFundType = 2
      }
      await this.$refs.transferForm.validate()
      const res = await advances.refundFront(this.transferForm)
      if (res.code === 200) {
        if (res.data.prompt) {
          Dialog.confirm({
            confirmButtonText: '继续',
            message: '<span style="color: #E6A23C;">提示（注：开户主体调拨错误的，依据制度经办人成长200元/笔，请认真核查。）</span>\n' + res.data.prompt
          })
            .then(async () => {
              await this.addTransfer(res.data.association)
            })
        } else {
          await this.addTransfer(res.data.association)
        }
      }
    },
    async addTransfer(data) {
      await advances.addRefund(data).then(res => {
        if (res.code == 200) {
          Toast.success(res.msg)
          this.selectType()
          this.visible = false
          this.resultTitle = '调拨结果'
          this.resultVisible = true
          this.refundResultList = res.data.consumeList
          this.rechargeResultList = res.data.alloExecAccounList
          setTimeout(async() => {
            if (this.$parent.$root._route.path === '/channel/recharge/rechargeApplication') { this.$parent.queryCustList() }
          }, 1500)
          this.accountId = null
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    async uploadPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.refundForm.refundUrl = res.url
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    handleRemove(file) {
      this.refundForm.refundUrl = ''
      this.pictureList = []
      return true
    },
    async beforeRefund(type) {
      if (type === 'medium') {
        this.refundForm.isRefundMedium = 1
      } else {
        this.refundForm.isRefundMedium = null
      }
      this.refundForm.accountId = this.accountId
      this.refundForm.accountType = this.accountIdInfo.accountType
      this.refundForm.contractId = this.accountIdInfo.contractId
      this.refundForm.execCustomerId = this.accountIdInfo.execCustomerId
      this.refundForm.projectId = this.accountIdInfo.projectId
      this.refundForm.percentage = this.accountIdInfo.percentage
      // if (this.accountIdInfo.projectName.indexOf('自运营') > -1 || this.accountIdInfo.projectName.indexOf('品牌单') > -1) {
      //   this.refundForm.fundType = 2
      // } else if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
      //   this.refundForm.fundType = 1
      // }
      if (this.accountIdInfo.projectName.indexOf('代运营') > -1) {
        this.refundForm.fundType = 1
      } else {
        this.refundForm.fundType = 2
      }
      await this.$refs.refundForm.validate()
      this.refundVisible = true
    },
    // 退款
    async saveRefund(type) {
      if (type === 'advances') {
        if (Number(this.refundForm.rechargeMoney) > Number(this.refundForm.rechargeAmount)) {
          Toast.fail('退款金额不能大于垫款未回款金额！')
          return
        }
        this.refundForm.isRefundAdvances = 1
      }
      await advances.addRefund(this.refundForm).then(res => {
        if (res.code == 200) {
          Toast.success(res.msg)
          this.continueRefundUrl = this.refundForm.refundUrl
          this.continueRefundReason = this.refundForm.refundReason
          this.refundForm = {}
          // this.pictureList = []
          // this.visible = false
          this.refundVisible = false
          this.resultTitle = '退款结果'
          this.resultVisible = true
          this.refundResultList = res.data
          setTimeout(async() => {
            if (this.$parent.$root._route.path === '/channel/recharge/rechargeApplication') { this.$parent.queryCustList() }
          }, 1500)
          this.accountId = null
          // this.selectType()
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    continueRefund(type, done) {
      // if (type === 'confirm') {
      //   this.accountIdInfo = {}
      //   this.resultVisible = false
      //   return done()
      // } else {
      //   this.resultVisible = false
      //   this.visible = false
      //   this.selectType()
      //   return done()
      // }
      this.resultVisible = false
      this.accountIdInfo = {}
      // this.visible = false
      // this.selectType()
    },
    // 查看凭证
    viewCredentials() {
      const form = {
        outAccountId: null,
        outAccountName: null,
        toAccountId: null,
        toAccountName: null,
        money: null,
        time: null
      }
      if (this.resultTitle === '充值结果') {
        if (this.rechargeResultList.length > 0 && this.rechargeResultList.every(item => { return item.rechargeStatus === 2 })) {
          form.outAccountId = this.rechargeResultList[0].serviceId
          form.outAccountName = this.rechargeResultList[0].serviceName
          form.toAccountId = this.rechargeResultList[0].accountNo
          form.toAccountName = this.rechargeResultList[0].accountName
          form.money = this.rechargeResultList.reduce((total, item) => total + Number(item.rechargeMoney), 0).toFixed(2)
          form.time = this.rechargeResultList[0].mediaTime
        } else {
          Toast.fail('充值存在失败记录，无法查看凭证!')
          return
        }
      } else if (this.resultTitle === '退款结果') {
        if (this.refundResultList.length > 0 && this.refundResultList.every(item => { return item.rechargeType !== 4 })) {
          form.toAccountId = this.refundResultList[0].serviceId
          form.toAccountName = this.refundResultList[0].serviceName
          form.outAccountId = this.refundResultList[0].accountId
          form.outAccountName = this.refundResultList[0].corporationName
          form.money = this.refundResultList.reduce((total, item) => total + Number(item.rechargeMoney), 0).toFixed(2)
          form.time = this.refundResultList[0].consumeDate
        } else {
          Toast.fail('退款存在失败记录，无法查看凭证!')
          return
        }
      } else if (this.resultTitle === '调拨结果') {
        if (this.rechargeResultList.length > 0 && this.refundResultList.length > 0 && this.rechargeResultList.every(item => { return item.rechargeStatus === 2 }) && this.refundResultList.every(item => { return item.rechargeType !== 4 })) {
          form.outAccountId = this.refundResultList[0].accountId
          form.outAccountName = this.refundResultList[0].corporationName
          form.toAccountId = this.rechargeResultList[0].accountNo
          form.toAccountName = this.rechargeResultList[0].corporationName
          form.money = this.rechargeResultList.reduce((total, item) => total + Number(item.rechargeMoney), 0).toFixed(2)
          form.time = this.rechargeResultList[0].mediaTime
        } else {
          Toast.fail('调拨存在失败记录，无法查看凭证!')
          return
        }
      }
      this.resultVisible = false
      this.visible = false
      console.log(this.$parent)
      if (this.$parent._data.popupShow) { this.$parent._data.popupShow = false }
      this.$router.push({
        path: '/channel/recharge/credentials',
        query: form
      })
    },

    async showPicker(type, form) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.form = form
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'project') {
        this.picker.columns = this.projectList.map((ele) => `【${ele.percentage}%/${ele.calculationMethodStr}】${getValue(ele.projectName)} | ${ele.industryName ? ele.industryName : '-'}`)
        this.picker.loading = false
      } else if (type === 'execCustomer') {
        this.picker.columns = this.execCustomerList.map((ele) => ele.bussUserName + '：' + ele.execCustomerName)
        this.picker.loading = false
      } else if (type === 'serviceId') {
        this.picker.columns = this.serviceIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else if (type === 'subAccountId') {
        this.picker.columns = this.subAccountIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else if (type === 'allotTenFundType') {
        this.picker.columns = this.options.tenFundTypeOptions.map((ele) => ele.dictLabel)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'
      if (this.picker.formKey === 'execCustomer') {
        this.bindForm.execCustomerId = this.execCustomerList[key].execCustomerId
        this.bindForm.execCustomerName = this.execCustomerList[key].execCustomerName
        this.getProjectList(2, this.execCustomerList[key].execCustomerId)
      } else if (this.picker.formKey === 'project') {
        this.bindForm.projectId = this.projectList[key].projectId
        this.bindForm.projectName = this.projectList[key].projectName
      } else if (this.picker.formKey === 'serviceId') {
        if (this.picker.form === 'refundServiceId') {
          this.refundServiceName = this.serviceIdList[key].accountId + '  ' + this.serviceIdList[key].remark
          this.refundServiceId = this.serviceIdList[key].accountId
        } else if (this.picker.form === 'transferForm') {
          this.transferForm.allotServiceName = this.serviceIdList[key].accountId + '  ' + this.serviceIdList[key].remark
          this.transferForm.allotServiceId = this.serviceIdList[key].accountId
        } else {
          this[this.picker.form].serviceName = this.serviceIdList[key].accountId + '  ' + this.serviceIdList[key].remark
          this[this.picker.form].serviceId = this.serviceIdList[key].accountId
          if (this.picker.form === 'rechargeForm') {
            await this.getAccountBalance('rechargeForm')
          }
        }
      } else if (this.picker.formKey === 'subAccountId') {
        this[this.picker.form].subAccountName = this.subAccountIdList[key].accountId + '  ' + this.subAccountIdList[key].remark
        this[this.picker.form].subAccountId = this.subAccountIdList[key].accountId
      } else if (this.picker.formKey === 'tenFundType') {
        this[this.picker.form].tenFundType = this.options[optionItem][key].dictValue
        this[this.picker.form].tenFundTypeName = this.options[optionItem][key].dictLabel
      } else if (this.picker.formKey === 'allotTenFundType') {
        this[this.picker.form].allotTenFundType = this.options.tenFundTypeOptions[key].dictValue
        this[this.picker.form].allotTenFundTypeName = this.options.tenFundTypeOptions[key].dictLabel
      } else {
        this[this.picker.form][this.picker.formKey] = this.options[optionItem][key].dictValue
        this[this.picker.form][name] = this.options[optionItem][key].dictLabel
      }

      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    showCalendar(type, form) {
      this.datePicker.form = form
      this.datePicker.formKey = type
      this.datePicker.type = 'single'
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      this[this.datePicker.form][this.datePicker.formKey] = this.formatDate(date)
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },

    showImg(val) {
      this.imageArr = []
      this.imageArr.push(val)
      this.imageShow = true
    },
    async getOptions() {
      // 框架类型
      await this.getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      await this.getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      await this.getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      await this.getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
      await this.getDicts('advances_type').then(res => {
        this.options.advancesTypeOptions = res.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");
.van-search__action:active {
  background-color: #fff;
}
.authId_dialog /deep/.van-dialog__content {
  height: 78%;
}
.editClue /deep/ .van-dialog__header{
  display: flex;
  justify-content: center;
}
.editClue /deep/.van-dialog__content {
  height: 93%;
  overflow-y: scroll;
}
.editClue /deep/.van-dialog__footer{
  display: none;
}
.serviceId /deep/.van-dialog__content {
  height: 48%;
}
.result_dialog {
  /deep/ .van-dialog__content {
    height: 86%;
  }
}
.result_dialog /deep/.van-dialog__footer{
  display: none;
}
.footer00{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 80%;
    margin: 0 auto;
    border: 1px #f4f4f4 solid;
  }
}
.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 33.3%;
    border: 1px #f4f4f4 solid;
  }
}
.footer2{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 50%;
    border: 1px #f4f4f4 solid;
  }
}

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 80%;
}
.verifyClue /deep/.van-dialog__header {
  background-color: #d4d4d4;
}
.mediaRecharge_form /deep/.van-dialog__content {
  height: 73%;
}
.reject_form /deep/.van-dialog__content {
  height: 43%;
}
.media /deep/.van-dialog__content {
  height: 67%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
.refundForm /deep/ .van-cell__value {
  min-width: 62%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
/deep/ .van-list {
  padding: 0;
}
/deep/.van_list{
  max-height: 460px;
  overflow-y: scroll;
}
/deep/.van-collapse-item__content{
  padding: 0 14px;
}
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}

.table:first-child {
  border-top: 2px solid #ddd;
}
.table {
  display: flex;
  // align-items: center;
  border: 2px solid #ddd;
  border-top: none;
  line-height: 50px;
  font-size: 24px;
  // text-align: center;
  color: #666;
  .td {
    width: 25%;
    border-top: 2px solid #ddd;
    border-right: 2px solid #ddd;
    padding-left: 8px;
    background-color: #f4f4f4;
  }
  .td2 {
    width: 53%;
  }
  .td:first-child {
    border-top: none;
  }
  // .td:last-child {
  //   border-right: none;
  // }
  .tb{
    width: 75%;
    padding-left: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bz{
    width: 75%;
    padding-left: 8px;
    line-height: 36px;
  }
  .tb2{
    width: 50%;
  }
}
.refund_button{
  padding: 40px 0px 50px;
  display: flex;
  justify-content: space-around;
  /deep/ .van-button--small{
    padding: 0 30px;
  }
}
</style>
